import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import {
    Card,
    Col,
    Nav,
    NavItem,
    NavLink,
    Row,
} from 'reactstrap';

import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';

const Tabs = ({
    t,
    organization,
}) => {
    const [activeTab, setActiveTab] = useState('');
    const history = useHistory();
    const location = useLocation();

    const isActiveTab = (currentTab, tab) => currentTab === tab;

    const tabsLinks = useMemo(() => {
        const links = [
            {
                key: 'overview',
                title: t('TPDD'),
            },
        ];

        const isDemoOrganization = organization?.id === 2;

        if (isDemoOrganization && isFeatureEnabledForActiveModule('eudr_activation')) {
            links.push({
                key: 'eudr',
                title: t('EUDR'),
            });
        }

        if (isDemoOrganization && isFeatureEnabledForActiveModule('PPWR')) {
            links.push({
                key: 'ppwr',
                title: t('PPWR'),
            });
        }

        return links;
    }, [t, organization]);

    const shouldShowTabs = tabsLinks.length > 1;

    useEffect(() => {
        if (!tabsLinks.length) {
            return;
        }

        const tabKey = (new URLSearchParams(location.search)).get('tab');
        const tab = tabsLinks.find((item) => item.key === tabKey);

        if (!tab) {
            history.push({
                search: `?tab=${tabsLinks[0].key}`,
            });
        } else {
            setActiveTab(tab.key);
        }
    }, [
        location.search,
        tabsLinks,
        history,
    ]);

    if (!shouldShowTabs) {
        return null;
    }

    return (
        <Row>
            <Col sm="12" md="12" lg="6" xl="5">
                <Card>
                    <Nav tabs className="nav-tabs-custom nav-justified">
                        {tabsLinks.map((link) => (
                            <NavItem
                                className={isActiveTab(activeTab, link.key) ? 'active' : ''}
                                key={link.key}
                            >
                                <NavLink
                                    className={isActiveTab(activeTab, link.key) ? 'active' : ''}
                                    onClick={() => history.push({
                                        search: `?tab=${link.key}`,
                                    })}
                                >
                                    {link.title}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </Card>
            </Col>
        </Row>
    );
};

const mapStateToProps = (state) => ({
    organization: state.Organization,
});

export default withNamespaces()(withRouter(connect(mapStateToProps)(Tabs)));
